import { AppThemeConstants } from '../utils';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
export const globalStyles = {
  colors: {
    black: '#333333',
    blue: {
      100: '#f2f8ff',
      150: '#E6EFFB',
      200: '#d6e3f4',
      300: '#bbcfea',
      400: '#8dabd4',
      500: '#648abf',
      600: '#426da9',
      700: '#1d4f91',
      800: '#123f7a',
      900: '#0a3163',
    },
    gray: {
      100: '#f6f6f6',
      200: '#eaeaea',
      300: '#d6d6d6',
      400: '#c1c1c1',
      500: '#a7a7a7',
      600: '#8c8c8c',
      700: '#717171',
      800: '#585858',
      900: '#404040',
    },
    green: {
      100: '#F2FFF5',
      200: '#D0F6DB',
      300: '#9AE8B4',
      400: '#5CD08E',
      500: '#29B769',
      600: '#009f4d',
      700: '#007a3b',
      800: '#00612F',
      900: '#004A24',
    },
    lime: {
      100: '#fefff2',
      200: '#f7f9cc',
      300: '#f0f3a7',
      400: '#dce26d',
      500: '#cad03b',
      600: '#b7bf10',
      700: '#979e08',
      800: '#777d03',
      900: '#575c00',
    },
    magenta: {
      100: '#fff1fa',
      200: '#ffd8f0',
      300: '#ffc0e4',
      400: '#f790c6',
      500: '#ef62a8',
      600: '#e63888',
      700: '#c41d73',
      800: '#a20861',
      900: '#800051',
    },
    orange: {
      100: '#fff9f2',
      200: '#ffeed7',
      300: '#ffe3ba',
      400: '#ffc684',
      500: '#ffaa4f',
      600: '#ff8f1c',
      700: '#cc6e0f',
      800: '#995006',
      900: '#663300',
    },
    purple: {
      100: '#fef2ff',
      200: '#eed3f1',
      300: '#dfb6e4',
      400: '#c186c9',
      500: '#a45dad',
      600: '#883b92',
      700: '#6d2077',
      800: '#53135b',
      900: '#390a40',
    },
    raspberry: {
      100: '#fff0fb',
      200: '#f6cbea',
      300: '#eda7da',
      400: '#d86fbc',
      500: '#c43e9f',
      600: '#af1685',
      700: '#92086d',
      800: '#760056',
      900: '#570041',
    },
    red: {
      100: '#fff0f3',
      200: '#FFD6DD',
      300: '#fea8b8',
      400: '#f66c86',
      500: '#ed3457',
      600: '#e4002b',
      700: '#c60025',
      800: '#a8001f',
      900: '#8a0019',
    },
    sapphire: {
      100: '#f2fcff',
      200: '#d0eff8',
      300: '#afe2f1',
      400: '#79c8de',
      500: '#4aafcc',
      600: '#2197b9',
      700: '#0081a6',
      800: '#006580',
      900: '#004759',
    },
    teal: {
      100: '#f2fffe',
      200: '#c6f7f4',
      300: '#9befea',
      400: '#5fdad4',
      500: '#2bc6be',
      600: '#00b2a9',
      700: '#00948c',
      800: '#00756f',
      900: '#005752',
    },
    transparent: 'transparent',
    white: '#ffffff',
    ...[10, 20, 30, 40, 50, 60, 70, 80, 90]
      .map((x) => ({ [`white-a${x}`]: `rgba(255, 255, 255, ${x / 100})` }))
      .reduce((whites, white) => Object.assign({}, whites, white), {}),
    yellow: {
      100: '#FFF9E8',
      200: '#FFF1BD',
      300: '#FFEA90',
      400: '#FFD146',
      500: '#FEBA00',
      600: '#D49A00',
      700: '#AA7A00',
      800: '#815B00',
      900: '#573D00',
    },
    primary: AppThemeConstants.PRIMARY_COLOR,
    secondary: '#FAFBFE',
  },
  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        overflowX: 'hidden',
        bg: mode('white', '#000')(props),
        color: mode('gray.800', 'whiteAlpha.900')(props),
        fontFamily: 'Roboto',
        letterSpacing: '-0.5px',
      },
      input: {
        color: 'gray.700',
      },
      html: {
        fontFamily: 'DM Sans',
      },
      heading: `Roboto`,
    }),
  },
};
